const ITEMS = [
  "50 Red Flags",
  "Real World Examples",
  "Action Steps",
  "Glossary",
  "Bookkeeping Health Score",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-lg sm:text-xl italic text-white/95">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-[#C5A253]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden bg-[#20C9C3] py-4 sm:py-5"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
      <Row />
      <Row />
    </div>
  </div>
);
